import { useContext, useReducer } from "react";
import { Loading, Modelos } from "./Modelos";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { PostSinToken } from "../Rutas/ApiRest";
import { cuentaCliente } from "../Rutas/Servicios";


function RestablecerContrasena()
{
    const [state,dispatch]=useReducer(reducer,{token:"",contrasena:"",contrasenarepite:""})
    const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)

    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":return{token:"",contrasena:"",contrasenarepite:""}
      }
     
      return state;
    }

    function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }
    const sleep = (ms:any) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };
     const validar= ()=>
        {
            if(state.contrasena==state.contrasenarepite)
                {
                     var body={
                                      "Token": state.token,
                                      "contrasena":state.contrasena
                                    }
                              const verificar=PostSinToken(cuentaCliente.RestablecerContrasena,JSON.stringify(body),"application/json")
                              verificar?.then(async resultado=>{SetMensajeEmergente(resultado);SetLoading(false);
                                if(resultado.includes("eShopex.cl"))
                                  {
                                      await sleep(8000)
                                      window.location.href="https://eshopex.cl/";
                                  }
                                
                              })
                }else
                {
                    SetLoading(false)
                    SetMensajeEmergente("Las contraseñas ingresadas no son idénticas. Intente nuevamente.")
                }

                dispatch({type:"Reinicio"})
        }


    return (<>
    <div className="container">
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex justify-content-center py-4"> <a className="logo d-flex align-items-center w-auto img-fluid" href="https://eshopex.cl"> <img  alt=""></img></a> </div>
            

            <div className="card mb-3">
              <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Confirmacion para recuperar contraseña</h5>
                </div>
                <div className="row g-3 needs-validation" >
                  <div className="col-12">
                    <div className="input-group has-validation">
                    <input name="token" type="text"  id="token" className="form-control" placeholder="Código de recuperación" value={state.token} onChange={cambio}></input>
                     
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-group has-validation">
                    <input name="contrasena" type="password"  id="contrasena" className="form-control" placeholder="Nueva contraseña" value={state.contrasena} onChange={cambio}></input>
                      
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-group has-validation">
                    <input name="contrasenarepite" type="password"  id="contrasenarepite" className="form-control" placeholder="Repita nueva contraseña" value={state.contrasenarepite} onChange={cambio}></input>
                      
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary w-100" type="submit" style={{color:"#fff",backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>{SetLoading(true);validar()}}>Cambiar Contraseña</button>
                  </div>
                 

                  <div className="col-12">
                    <p className="small"><a href="../" style={{textDecoration:"none",color:"#f98824"}}>Volver</a></p>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
  <Modelos></Modelos>
 <Loading></Loading>

  </>

    )
}

export default RestablecerContrasena;